"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    style: style,
    width: "18px",
    height: "29px",
    viewBox: "0 0 18 29"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0,0.9982 C0,0.4472 0.445,0.0002 0.993,0.0002 L17.007,0.0002 C17.555,0.0002 18,0.4552 18,0.9982 L18,28.0022 C18,28.5532 17.555,29.0002 17.007,29.0002 L0.993,29.0002 C0.445,29.0002 0,28.5442 0,28.0022 L0,0.9982 Z M6,25.7902 C6,25.3542 6.357,25.0002 6.809,25.0002 L11.191,25.0002 C11.638,25.0002 12,25.3482 12,25.7902 L12,26.2092 C12,26.6462 11.643,27.0002 11.191,27.0002 L6.809,27.0002 C6.362,27.0002 6,26.6512 6,26.2092 L6,25.7902 Z M3,23.0002 L15,23.0002 L15,3.0002 L3,3.0002 L3,23.0002 Z"
  })));
};

exports["default"] = _default;